// external dependencies
import React from 'react';

/**
 * MapMarkerIcon
 *
 * Default SVG component for a generic map marker. Can be resized to 1.3 it's normal size if the incoming
 * "isExpanded" prop is set to TRUE. Also the 2 colors being used are flexible and can be changed via props.
 */
export function MapMarkerIcon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#E7040F' : _ref$fill,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 35 : _ref$height,
      _ref$innerFill = _ref.innerFill,
      innerFill = _ref$innerFill === void 0 ? '#FF725C' : _ref$innerFill,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      onClick = _ref.onClick,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 'auto' : _ref$zIndex;
  var scalar = isExpanded ? 1.3 : 1;
  var wrapperStyles = {
    cursor: 'pointer',
    display: 'inline-block',
    height: height,
    left: width / -2,
    position: 'absolute',
    top: height * -1,
    transform: "scale(".concat(scalar, ", ").concat(scalar, ")"),
    transformOrigin: "".concat(width / 2, "px ").concat(height, "px"),
    transition: 'transform 0.5s',
    verticalAlign: 'middle',
    width: width,
    zIndex: zIndex
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    style: wrapperStyles
  }, /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 363.91 485.21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.8,0c-100.48,0-182,81.47-182,182A181.13,181.13,0,0,0,97.16,291L242.8,485.21,388.45,291A181.11,181.11,0,0,0,424.76,182C424.76,81.47,343.29,0,242.8,0Zm0,303.26A121.3,121.3,0,1,1,364.1,182,121.31,121.31,0,0,1,242.8,303.26Z",
    transform: "translate(-60.85)",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "181.96",
    cy: "182",
    r: "121",
    style: {
      fill: innerFill
    }
  })));
}